import constants from '@/constants';
import emrTypeHelper from '@/helper/emrType';
import dayjs from 'dayjs';
import React, { useCallback } from 'react';
import _ from 'lodash';
/**
 * Generate a RecordByTypeItem component that displays data based on propsData and applies rowFn if provided.
 *
 * @param {Props} data - Object containing the data and date
 * @param {Function} rowFn - Optional function to format the data
 * @return {JSX.Element} Rendered React component
 */

interface Props {
  data?: IEMRData;
  rowFn?: any;
  emrType?: IEMRType;
}

const RecordByTypeItem = ({ data: propsData, rowFn, emrType }: Props) => {
  const renderCol = useCallback(() => {
    return rowFn ? (
      rowFn?.map((config: any | Index, key: number) => {
        const data_: any = {};
        Object.keys(config.routeValue || {})?.forEach((k) => {
          const route: string = config.routeValue?.[k]?.value || config.routeValue?.[k];
          const routeConfig = config.routeValue?.[k]?.config;

          data_[k] = _.get(propsData, route);
          if (routeConfig && emrType) {
            const [, fieldKey] = routeConfig.split('.');
            const fieldConfig: IFieldConfig = emrTypeHelper.getFieldConfig(emrType, fieldKey as string) as IFieldConfig;
            const valueOption = emrTypeHelper.getOption(fieldConfig, data_[k]);
            if (valueOption) {
              data_[k] = `<span style="color: ${valueOption.color}">
                            ${valueOption.label}
                          </span>`;
              if (!valueOption.label) {
                data_[k] = '';
              }
            } else if (fieldConfig?.inputType === 'date') {
              data_[k] = data_[k]
                ? dayjs(data_[k]).format(fieldConfig.extra.format || constants.TIME_FORMAT)
                : data_[k];
            }
          }
        });

        const show = config?.format?.replace(/\{([\w.]+)\}/g, (match: any, key: string | number) => {
          return typeof data_?.[key] !== 'undefined' ? data_?.[key] : '--';
        });

        if (config.noDataIsHidden || !propsData || !show) {
          return <></>;
        }

        return (
          <div
            key={key}
            style={{ width: config.width ? `${config.width * 100}%` : '100%' }}
            className="flex flex-row items-center mb-1"
          >
            {config?.icon ? <img src={config?.icon} className="w-4 h-4 mr-1" /> : <></>}
            <span
              className="flex flex-1 text-ellipsis overflow-hidden ml-"
              dangerouslySetInnerHTML={{ __html: show ?? '--' }}
            />
          </div>
        );
      })
    ) : (
      <></>
    );
  }, [propsData, rowFn, emrType]);

  // const rowShow = rowFn ? rowFn?.map((config: any | Index, key: number) => {
  //   const data_: any = {};
  //   Object.keys(config.routeValue || {})?.forEach((k) => {
  //     const route: string = config.routeValue?.[k]?.value || config.routeValue?.[k];
  //     const routeConfig = config.routeValue?.[k]?.config;

  //     data_[k] = _.get(propsData, route);
  //     if (routeConfig) {
  //       const [emrTypeCode, fieldKey] = routeConfig.split('.');
  //       const fieldConfig: IFieldConfig = emrType?.format.fields.find(
  //         (f) => f.key === fieldKey,
  //       ) as IFieldConfig;
  //       const valueOption = emrTypeHelper.getOption(fieldConfig, data_[k]);
  //       if (valueOption) {
  //         data_[k] = `<b style="color: ${valueOption.color}">
  //                         ${valueOption.label}
  //                       </b>`;
  //       } else if (fieldConfig?.inputType === 'date') {
  //         data_[k] = data_[k]
  //           ? dayjs(data_[k]).format(fieldConfig.extra.format || constants.TIME_FORMAT)
  //           : data_[k];
  //       }
  //     }
  //   });
  //   const show = config?.format?.replace(/\{([\w.]+)\}/g, (match: any, key: string | number) => {
  //     return typeof data_?.[key] !== 'undefined' ? data_?.[key] : '--';
  //   });

  //   if (config.noDataIsHidden && !propsData) {
  //     return;
  //   }
  //   return <div key={key} style={{ width: config.width ? `${config.width * 100}%` : '100%' }} className='flex flex-row items-center'>
  //     {config?.icon ? <img src={config?.icon} className='w-4 h-4 mr-1' /> : <></>}
  //     <div
  //       className='flex flex-1'
  //       dangerouslySetInnerHTML={{ __html: show }}
  //     />
  //   </div>
  // }) : []

  // const show = config?.format?.replace(/\{([\w.]+)\}/g, (match: any, key: string | number) => {
  //   return typeof data?.[key] !== 'undefined' ? data?.[key] : '--';
  // });

  // const show = rowFn
  //   ? rowFn(data)?.format?.map((i: string) =>
  //       i.replace(/\{([\w.[\]]+)\}/g, (match: any, key: string | number) => {
  //         const valueChange = _.get(propsData, key, '--');
  //         const evaluate = medicalConditionOptions?.find(i => i.value === valueChange)
  //         if(evaluate) {
  //           return `<span style="color: ${evaluate?.color}">${evaluate?.label}</span> `
  //         }
  //         return `<span class="text-ellipsis overflow-hidden">${valueChange}</span>`
  //       }),
  //     )
  //   : [];

  // const show = rowFn
  //   ? rowFn(data)?.format?.map(({ formatValue }: { formatValue: any }) => formatValue && formatValue(data, emrType)) : []
  //   i.replace(/\{([\w.[\]]+)\}/g, (match: any, key: string | number) => {
  //     const valueChange = _.get(propsData, key, '--');
  //     const evaluate = medicalConditionOptions?.find(i => i.value === valueChange)
  //     if(evaluate) {
  //       return `<span style="color: ${evaluate?.color}">${evaluate?.label}</span> `
  //     }
  //     return `<span class="text-ellipsis overflow-hidden">${valueChange}</span>`
  //   }),
  // )

  return (
    <div className="flex flex-row p-2 mx-6 shadow-md bg-gray-1 mb-2 rounded-lg ">
      <img
        src="https://letsenhance.io/static/8f5e523ee6b2479e26ecc91b9c25261e/1015f/MainAfter.jpg"
        className="w-14 h-14 mr-2 rounded"
      />
      <div className="flex flex-row flex-wrap items-start w-full">{renderCol()}</div>
    </div>
  );
};

export default RecordByTypeItem;
